module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_40ft_desktop-f9607918c33d2c1b7958e38789e227c9.png";